import React, { useEffect, useState, useRef, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, ChevronDownIcon } from 'lucide-react';
const MATH_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/cTqFhyqRMG8rzXYrQZXdLU/WhatsApp_Image_2026-03-10_at_19.23.56_(2).jpg',
  alt: 'Trabajo Práctico Matemática - Página 1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/sCVy2tKUYKviSR9TdEwT8Q/WhatsApp_Image_2026-03-10_at_19.23.56_(1)_(1).jpg',
  alt: 'Trabajo Práctico Matemática - Página 2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/d9AYndGym4EjbXgTBCZsJU/WhatsApp_Image_2026-03-10_at_19.23.57_(4).jpg',
  alt: 'Trabajo Práctico Matemática - Página 3'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rCpCDgZhap5XGuWb82ywTE/WhatsApp_Image_2026-03-10_at_19.23.57_(1)_(2).jpg',
  alt: 'Trabajo Práctico Matemática - Página 4'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/63jbLvCU7t3fWKyV3rvZpC/WhatsApp_Image_2026-03-10_at_19.23.57_(2)_(1).jpg',
  alt: 'Trabajo Práctico Matemática - Página 5'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5Z7rSyet89G3ge6PoNGGwN/WhatsApp_Image_2026-03-10_at_19.23.57_(3)_(1).jpg',
  alt: 'Trabajo Práctico Matemática - Página 6'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/n6KErEJ162ct3LPrgYqAUE/WhatsApp_Image_2026-03-10_at_19.23.58_(3).jpg',
  alt: 'Trabajo Práctico Matemática - Página 7'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/fZqEpSH4NkvvMWbK1geYUj/WhatsApp_Image_2026-03-10_at_19.23.58_(1)_(1).jpg',
  alt: 'Trabajo Práctico Matemática - Página 8'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iu9VQ8amHXZLSPrbYthYTz/WhatsApp_Image_2026-03-10_at_19.23.58_(2)_(1).jpg',
  alt: 'Trabajo Práctico Matemática - Página 9'
}];
const HISTORY_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/vuuVHT69W3vxb4uEskCsmC/WhatsApp_Image_2026-03-10_at_19.51.07.jpg',
  alt: 'Trabajo Práctico Historia - Página 1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qdELmprVv3fzcPq2FSkm9q/WhatsApp_Image_2026-03-10_at_19.51.08.jpg',
  alt: 'Trabajo Práctico Historia - Página 2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/d2ZbLcyvAuuXZ4xYY211Nd/WhatsApp_Image_2026-03-10_at_19.51.08_(1).jpg',
  alt: 'Trabajo Práctico Historia - Página 3'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6CPkmPNZ9GsSbdDWM1dsWi/WhatsApp_Image_2026-03-10_at_19.51.08_(2).jpg',
  alt: 'Trabajo Práctico Historia - Página 4'
}];
const GEOGRAPHY_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/jSNVsyVRcxx3toRmYVXpZs/WhatsApp_Image_2026-03-10_at_20.06.03.jpg',
  alt: 'Trabajo Práctico Geografía - Página 1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nRPHRtKo9ycfZqNxkvmk3f/WhatsApp_Image_2026-03-10_at_20.06.03_(1).jpg',
  alt: 'Trabajo Práctico Geografía - Página 2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rFgAQY3xho8JwM97EVTWqd/WhatsApp_Image_2026-03-10_at_20.06.04.jpg',
  alt: 'Trabajo Práctico Geografía - Página 3'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5gqEQZVbYiUfeV3ZhRprC9/WhatsApp_Image_2026-03-10_at_20.06.04_(1).jpg',
  alt: 'Trabajo Práctico Geografía - Página 4'
}];
const LITERATURE_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/mZPuhNKGXNYMcghL5eujxo/WhatsApp_Image_2026-03-10_at_20.09.08.jpg',
  alt: 'Trabajo Práctico Lengua y Literatura - Página 1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/dDwUhw4B1s66J4H7k6g3wk/WhatsApp_Image_2026-03-10_at_20.09.08_(1).jpg',
  alt: 'Trabajo Práctico Lengua y Literatura - Página 2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9EpgLTFfZNQ9aYnk87t6Gc/WhatsApp_Image_2026-03-10_at_20.09.09.jpg',
  alt: 'Trabajo Práctico Lengua y Literatura - Página 3'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3a1sPVCxXkJTWZ85nYNnsw/WhatsApp_Image_2026-03-10_at_20.09.09_(1).jpg',
  alt: 'Trabajo Práctico Lengua y Literatura - Página 4'
}];
const ENGLISH_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/418WYUD6ZHNSoWRtkkthii/WhatsApp_Image_2026-03-10_at_20.12.30.jpg',
  alt: 'Trabajo Práctico Inglés - Página 1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/o91ksgq6jaa5L2aVkjsJqz/WhatsApp_Image_2026-03-10_at_20.12.30_(1).jpg',
  alt: 'Trabajo Práctico Inglés - Página 2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/amEU9UBbYa8HWsTYH7fLdr/WhatsApp_Image_2026-03-10_at_20.12.30_(2).jpg',
  alt: 'Trabajo Práctico Inglés - Página 3'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/55AqYwZFwvZn7VVus1oCJp/WhatsApp_Image_2026-03-10_at_20.12.31.jpg',
  alt: 'Trabajo Práctico Inglés - Página 4'
}];
const SUBJECTS = [{
  id: 'math',
  emoji: '📐',
  label: 'Matemática',
  images: MATH_IMAGES
}, {
  id: 'history',
  emoji: '📜',
  label: 'Historia',
  images: HISTORY_IMAGES
}, {
  id: 'geography',
  emoji: '🌍',
  label: 'Geografía',
  images: GEOGRAPHY_IMAGES
}, {
  id: 'literature',
  emoji: '📖',
  label: 'Lengua y Literatura',
  images: LITERATURE_IMAGES
}, {
  id: 'english',
  emoji: '🇬🇧',
  label: 'Inglés',
  images: ENGLISH_IMAGES
}] as const;
export function ExamplesSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedSubject, setSelectedSubject] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const activeSubject = SUBJECTS[selectedSubject];
  const activeImages = activeSubject.images;
  // Reset carousel when subject changes
  useEffect(() => {
    setCurrentIndex(0);
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    }
  }, [selectedSubject]);
  const scrollRaf = useRef(0);
  const handleScroll = () => {
    cancelAnimationFrame(scrollRaf.current);
    scrollRaf.current = requestAnimationFrame(() => {
      if (!scrollRef.current || !scrollRef.current.children[0]) return;
      const scrollPosition = scrollRef.current.scrollLeft;
      const itemWidth = (scrollRef.current.children[0] as HTMLElement).offsetWidth + 12;
      const newIndex = Math.round(scrollPosition / itemWidth);
      setCurrentIndex(newIndex);
    });
  };
  const scroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current || !scrollRef.current.children[0]) return;
    const itemWidth = scrollRef.current.children[0].clientWidth + 12;
    scrollRef.current.scrollBy({
      left: direction === 'left' ? -itemWidth : itemWidth,
      behavior: 'smooth'
    });
  };
  return <section className="pt-0 pb-14 bg-zinc-950 overflow-hidden relative" data-id="element-120">
      <div className="max-w-6xl mx-auto px-4" data-id="element-121">
        <div className="text-center mb-8" data-id="element-122">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-2xl md:text-4xl font-black uppercase tracking-tight text-white mb-4" data-id="element-123">
            Resultados Reales en 10 Minutos
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-124">
            Le indicamos lo que queríamos a la IA y nos generó estos trabajos
            prácticos <strong className="text-white" data-id="element-125">INCREÍBLES</strong> en nada
            más que 10 minutos. Elegí alguna materia para ver los ejemplos 👇
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="mt-3 text-sm text-yellow-500/80 font-semibold uppercase tracking-wide" data-id="element-126">
            Funciona para CUALQUIER materia y CUALQUIER nivel de docencia
          </motion.p>
        </div>

        {/* Subject Selector — just before carousel */}
        <div className="flex justify-center mb-5 relative z-20" data-id="element-127">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="relative inline-block" data-id="element-128">
            <button onClick={() => setDropdownOpen(!dropdownOpen)} className="inline-flex items-center gap-2 px-7 py-3 rounded-full border-2 border-green-400 bg-green-500 text-white text-sm md:text-base font-black uppercase tracking-widest cursor-pointer hover:bg-green-400 shadow-[0_0_20px_rgba(34,197,94,0.4)] hover:shadow-[0_0_30px_rgba(34,197,94,0.6)] transition-all animate-pulse" data-id="element-129">
              <span data-id="element-130">{activeSubject.emoji}</span>
              {activeSubject.label}
              <ChevronDownIcon className={`w-4 h-4 transition-transform ${dropdownOpen ? 'rotate-180' : ''}`} data-id="element-131" />
            </button>
            <AnimatePresence data-id="element-132">
              {dropdownOpen && <motion.div initial={{
              opacity: 0,
              y: -8,
              scale: 0.95
            }} animate={{
              opacity: 1,
              y: 0,
              scale: 1
            }} exit={{
              opacity: 0,
              y: -8,
              scale: 0.95
            }} transition={{
              duration: 0.15
            }} className="absolute top-full left-1/2 -translate-x-1/2 mt-2 bg-zinc-900 border border-zinc-700 rounded-xl shadow-2xl overflow-hidden z-30 min-w-[200px]" data-id="element-133">
                  {SUBJECTS.map((subject, idx) => <button key={subject.id} onClick={() => {
                setSelectedSubject(idx);
                setDropdownOpen(false);
              }} className={`w-full flex items-center gap-3 px-4 py-3 text-left text-sm font-medium transition-colors ${idx === selectedSubject ? 'bg-yellow-500/10 text-yellow-500' : 'text-gray-300 hover:bg-zinc-800 hover:text-white'}`} data-id="element-134">
                      <span className="text-lg" data-id="element-135">{subject.emoji}</span>
                      {subject.label}
                      <span className="ml-auto text-xs text-gray-500" data-id="element-136">
                        {subject.images.length} págs
                      </span>
                    </button>)}
                </motion.div>}
            </AnimatePresence>
          </motion.div>
        </div>

        <div className="relative" data-id="element-137">
          {/* Desktop Navigation Arrows */}
          <button onClick={() => scroll('left')} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-6 z-10 bg-zinc-900/90 border border-zinc-700 text-white p-3 rounded-full shadow-xl hover:bg-zinc-800 transition-colors hidden md:flex items-center justify-center" aria-label="Anterior" data-id="element-138">
            <ChevronLeftIcon className="w-6 h-6" data-id="element-139" />
          </button>

          <button onClick={() => scroll('right')} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-6 z-10 bg-zinc-900/90 border border-zinc-700 text-white p-3 rounded-full shadow-xl hover:bg-zinc-800 transition-colors hidden md:flex items-center justify-center" aria-label="Siguiente" data-id="element-140">
            <ChevronRightIcon className="w-6 h-6" data-id="element-141" />
          </button>

          {/* Carousel Container */}
          <div ref={scrollRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory gap-3 pb-4 pt-2 px-4 -mx-4 md:mx-0 md:px-0 scrollbar-hide" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-142">
            {activeImages.map((img, idx) => <div key={`${activeSubject.id}-${idx}`} className="w-[240px] md:w-[280px] flex-shrink-0 snap-start" data-id="element-143">
                <img src={img.src} alt={img.alt} loading="lazy" className="w-full h-auto rounded-xl border border-zinc-800 shadow-2xl object-cover" data-id="element-144" />
              </div>)}
          </div>

          {/* Page Indicator */}
          <div className="flex justify-center items-center gap-2 mt-2" data-id="element-145">
            <div className="bg-zinc-900 border border-zinc-800 px-4 py-1.5 rounded-full text-sm font-medium text-gray-400" data-id="element-146">
              <span className="text-white" data-id="element-147">{currentIndex + 1}</span> /{' '}
              {activeImages.length}
            </div>
          </div>
        </div>
      </div>
    </section>;
}